export enum ContentSubType {
  MQUpdate = 269,
  CCUpdate = 272
}
